import { useState } from 'react';
import { MemberSidebar } from './MemberDashboard';
import { useAuth } from '../context/AuthContext';
import api, { formatApiError } from '../lib/api';
import { CheckCircle } from '@phosphor-icons/react';

export default function MemberProfile() {
  const { user, checkAuth } = useAuth();
  const [form, setForm] = useState({
    firstName: user?.firstName || '',
    lastName: user?.lastName || '',
    phone: user?.phone || '',
    currentPassword: '',
    newPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const payload = { firstName: form.firstName, lastName: form.lastName, phone: form.phone };
      if (form.newPassword) {
        payload.currentPassword = form.currentPassword;
        payload.newPassword = form.newPassword;
      }
      await api.put('/member/profile', payload);
      setSuccess('Profil mis a jour avec succes.');
      setForm(p => ({ ...p, currentPassword: '', newPassword: '' }));
      await checkAuth();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    }
    setLoading(false);
  };

  const update = (field, value) => setForm(p => ({ ...p, [field]: value }));

  return (
    <div className="pt-20 min-h-screen" data-testid="member-profile-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          <MemberSidebar />
          <div className="flex-1 max-w-xl">
            <h1 className="font-heading text-3xl text-white mb-8">Mon profil</h1>
            <form onSubmit={handleSubmit} className="space-y-5" data-testid="profile-form">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-xs uppercase tracking-widest text-desti-gold mb-2 block">Prenom</label>
                  <input type="text" value={form.firstName} onChange={e => update('firstName', e.target.value)}
                    className="w-full bg-desti-black border-b border-white/20 px-3 py-3 text-white text-sm focus:outline-none focus:border-desti-gold transition-colors"
                    data-testid="profile-firstname-input" />
                </div>
                <div>
                  <label className="text-xs uppercase tracking-widest text-desti-gold mb-2 block">Nom</label>
                  <input type="text" value={form.lastName} onChange={e => update('lastName', e.target.value)}
                    className="w-full bg-desti-black border-b border-white/20 px-3 py-3 text-white text-sm focus:outline-none focus:border-desti-gold transition-colors"
                    data-testid="profile-lastname-input" />
                </div>
              </div>
              <div>
                <label className="text-xs uppercase tracking-widest text-desti-gold mb-2 block">Email</label>
                <input type="email" disabled value={user?.email || ''}
                  className="w-full bg-desti-black border-b border-white/10 px-3 py-3 text-white/40 text-sm cursor-not-allowed" />
              </div>
              <div>
                <label className="text-xs uppercase tracking-widest text-desti-gold mb-2 block">Telephone</label>
                <input type="tel" value={form.phone} onChange={e => update('phone', e.target.value)}
                  className="w-full bg-desti-black border-b border-white/20 px-3 py-3 text-white text-sm focus:outline-none focus:border-desti-gold transition-colors"
                  data-testid="profile-phone-input" />
              </div>
              <div className="pt-4 border-t border-white/5">
                <p className="text-xs uppercase tracking-widest text-desti-gold mb-4">Changer le mot de passe</p>
                <div className="space-y-4">
                  <input type="password" placeholder="Mot de passe actuel" value={form.currentPassword} onChange={e => update('currentPassword', e.target.value)}
                    className="w-full bg-desti-black border-b border-white/20 px-3 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-desti-gold transition-colors"
                    data-testid="profile-current-pw-input" />
                  <input type="password" placeholder="Nouveau mot de passe" value={form.newPassword} onChange={e => update('newPassword', e.target.value)}
                    className="w-full bg-desti-black border-b border-white/20 px-3 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-desti-gold transition-colors"
                    data-testid="profile-new-pw-input" />
                </div>
              </div>
              {error && <p className="text-red-400 text-sm" data-testid="profile-error">{error}</p>}
              {success && (
                <div className="flex items-center gap-2 text-green-400 text-sm" data-testid="profile-success">
                  <CheckCircle size={16} /> {success}
                </div>
              )}
              <button type="submit" disabled={loading}
                className="bg-desti-gold text-desti-black font-medium py-3 px-8 text-sm tracking-wide hover:bg-desti-gold-hover transition-colors disabled:opacity-50"
                data-testid="profile-submit-btn">
                {loading ? 'Mise a jour...' : 'Sauvegarder'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
